import React from 'react';
import { Outlet } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';
import { usePermissions } from '../../hooks/usePermissions';
import NoAccessToVerity from '../common/NoAccessToVerity';

/**
 * AppRouteGuard component
 *
 * Guards all application routes to ensure only users with proper permissions can access the app.
 * Users must have a valid userPermission record (from DB or synthetic LDAP record).
 *
 * If user has no LDAP membership and no DB record, shows NoAccessToVerity page.
 */
const AppRouteGuard: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { userPermission } = usePermissions();

  // If user is not authenticated, let AuthProvider handle the redirect
  if (!isAuthenticated) {
    return <Outlet />;
  }

  // Check if user has any permissions (either from DB or synthetic LDAP record)
  // userPermission will be null only if user has no LDAP membership and no DB record
  const hasAccess = userPermission !== null;

  // If user doesn't have access, show restricted page
  if (!hasAccess) {
    return <NoAccessToVerity />;
  }

  // If user has access, render the child routes
  return <Outlet />;
};

export default AppRouteGuard;
